import PMBSelect from 'components/PMBSelect'
import { useSnackbar } from 'notistack'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, FormGroup, Label, Modal, ModalBody } from 'reactstrap'
import IconUpdateVessel from '../../../../assets/icons/icon-edit-vessel.png'
import { useCreationVesselUsersMutation } from '../forms/formApiSlice'
import {
  useFetchFarmersQuery,
  useFetchVesselsQuery,
} from './vesselsListApiSlice'
import { setDetailVessel, toggleModalPemetaan } from './vesselsListSlice'

const ModalPemetaan = ({ row }) => {
  const idVessel = row?.id

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  const { isOpenModalPemetaan, tag, detailVessel } = useSelector(
    (s) => s.vesselsList,
  )

  const [creationVesselUsers, { isLoading: isLoadingCreateVesselUsers }] =
    useCreationVesselUsersMutation()

  let [page, setPage] = useState({ page: tag.page ?? 0 })

  const { data: dataUsers, isLoading } = useFetchFarmersQuery({
    page: page?.page,
    status: 'ALLMEMBER',
    size: 999,
  })

  // MAPPING DATA USER NELAYAN
  const nelayanOptions = dataUsers?.data?.items.map((user) => ({
    value: user.userId,
    label: user.name,
  }))

  const [errMsg, setErrMsg] = useState('')

  const [selectedNelayan, setSelectedNelayan] = useState([])

  const { refetch } = useFetchVesselsQuery({
    page: tag?.page ?? 0,
    size: 10,
    searchvalue: '',
  })

  const resetState = () => {
    setSelectedNelayan([])
    setErrMsg('')
  }

  // Handle Submit
  const handleSubmit = async () => {
    try {
      const payload = {
        ap2himastervesselsId: detailVessel?.id || idVessel,
        userIds: selectedNelayan?.map((nelayan) => nelayan?.value),
      }

      const res = await creationVesselUsers(payload)

      if (res?.error?.data) {
        enqueueSnackbar(
          res?.error?.data?.meta?.message ??
            `Pemetaan nelayan gagal  ${idVessel ? 'dirubah' : 'ditambahkan'}!`,
          { variant: 'error' },
        )

        setErrMsg(res?.error?.data?.message)
      } else if (typeof res?.data?.id === 'number') {
        dispatch(toggleModalPemetaan())
        dispatch(setDetailVessel({}))
        resetState()

        enqueueSnackbar(
          `Pemetaan nelayan berhasil  ${idVessel ? 'dirubah' : 'ditambahkan'}!`,
          { variant: 'success' },
        )

        refetch()

        navigate('/vessels')
      }
    } catch (error) {
      console.warn(error)
      enqueueSnackbar(
        `Pemetaan nelayan gagal  ${idVessel ? 'dirubah' : 'ditambahkan'}!`,
        { variant: 'error' },
      )
    }
  }

  useEffect(() => {
    if (errMsg) {
      setTimeout(() => {
        setErrMsg('')
      }, 3000)
    }
  }, [errMsg])

  // HANDLE EDIT
  useMemo(() => {
    if (row) {
      const nelayanData = row?.uservessels?.map((vessel) => ({
        value: vessel?.userId,
        label: vessel?.verifiedprofile?.name,
      }))
      setSelectedNelayan(nelayanData)
    }
  }, [row])

  return (
    <Modal
      className="p-4"
      centered
      isOpen={isOpenModalPemetaan}
      toggle={() => {
        dispatch(setDetailVessel({}))
        dispatch(toggleModalPemetaan())
        resetState()
      }}
      autoFocus={false}
      data-testid="vessel-modal-pemetaan"
    >
      <ModalBody>
        <img
          src={IconUpdateVessel}
          loading="lazy"
          style={{ marginBottom: '14px ' }}
        />
        <h5>Pemetaan Nelayan</h5>
        <p className="text-muted">Meliputi pemetaan ke nelayan</p>

        <FormGroup>
          <Label>Nelayan</Label>
          <PMBSelect
            options={nelayanOptions}
            value={selectedNelayan}
            onChange={(selectedOptions) => setSelectedNelayan(selectedOptions)}
            isMulti
            placeholder="Pilih Nelayan"
            testId="vessel-form-nelayan"
          />
          {/* <Select
            options={nelayanOptions}
            isMulti
            value={selectedNelayan}
            onChange={(selected) => setSelectedNelayan(selected)}
            placeholder="Pilih Nelayan"
          /> */}
        </FormGroup>

        <div className="d-flex gap-3">
          <Button
            onClick={() => {
              dispatch(setDetailVessel({}))
              dispatch(toggleModalPemetaan())
              resetState()
            }}
            color="primary"
            outline
            block
            data-testid="vessel-modal-pemetaan-cancel-button"
          >
            Batal
          </Button>
          <Button
            disabled={
              isLoadingCreateVesselUsers || selectedNelayan.length === 0
            }
            color="primary"
            block
            onClick={handleSubmit}
            data-testid="vessel-modal-pemetaan-submit-button"
          >
            {idVessel ? 'Ubah' : 'Tambah'} Pemetaan
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalPemetaan
